export default __webpack_public_path__ + "static/media/react-mockup.1a7cb78a.png";